import { Pipe, PipeTransform } from '@angular/core'
import { Moment } from 'moment'
import { alterInJahren } from '../util/alter.util'

@Pipe({
  name: 'age',
})
export class AgePipe implements PipeTransform {
  transform(value: Date | string | Moment): number {
    const dateOfBirth = value instanceof Date || typeof value === 'string' ? new Date(value) : value.toDate()
    return alterInJahren(dateOfBirth, new Date())
  }
}
